import Vue from 'vue';
import Router from 'vue-router';
import VuePageTitle from 'vue-page-title';

import originalRoutes from '@/system/router';
import newRoutes from '@/application/config/router';

if (newRoutes) originalRoutes[0].children = newRoutes.concat(originalRoutes[0].children);

Vue.use(Router);

const router = new Router({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes: originalRoutes
});

Vue.use(VuePageTitle, {
	prefix: 'GestiOS | ',
	router
});

let ready = false;
function onDeviceReady() { ready = true; }
document.addEventListener('deviceready', onDeviceReady, false);

router.beforeEach(async (to, from, next) => {
	const { auth } = to.meta;
	const isOnline = Vue.prototype.$gestios !== undefined ? Vue.prototype.$gestios.connected : false;

	if (auth && !isOnline) {
		next({ name: '_login' });
	} else if (to.name === '_login' && isOnline) {
		next({ name: '_home' });
	} else {
		let pass = false;
		if (auth) {
			pass = Vue.prototype.$gestios.auth.check({ scopes: auth.roles, strict: auth.strict });
		} else {
			pass = true;
		}

		if (pass) {
			if (to.name !== '_offline' && ready) {
				if (navigator.connection.type === 'none') {
					next({ name: '_offline' });
					return;
				}
			}

			if (to.matched.length > 0) {
				next();
			} else {
				next({ name: '_404' });
			}
		} else {
			next({ name: '_403' });
		}
	}
});

export default router;
